import styled from 'styled-components';
import { theme } from 'styles';
import { ERROR, NO_DATA } from 'utils';

export const SectionWrapper = styled.div<{ displayStyle?: NO_DATA; $marginY?: number }>`
  max-width: 1000px;
  border: 2px dashed ${({ displayStyle }) => (displayStyle === ERROR ? theme.color.error : theme.color.grey85)};
  background-color: ${({ displayStyle }) => (displayStyle === ERROR ? theme.color.palette_red_1 : theme.color.white)};
  border-radius: 20px;
  padding: 16px;
  margin: ${({ $marginY }) => ($marginY === undefined ? '25px' : `${$marginY}px`)} 0;
`;
